export const engageAgentRootPath = '/agent';
export const takeActionRootPath = '/take-action';
export const takeActionNotificationMatchPath = '/take-action/notification/:notificationId';

export const takeActionUrl = (notificationId: string): string => `${takeActionRootPath}/notification/${notificationId}`;
